import Regex from '../Regex'

export default class Decimal extends Regex {
  constructor ({
                 value,
                 customAttribute,
                 parameters = 2
               }) {
    super({
      value,
      customAttribute
    })
    this.maxDecimals = parameters
  }

  get ruleName () {
    return 'decimal'
  }

  message () {
    return this.replaceMessage(super.message(), 'number', this.maxDecimals)
  }

  passes () {
    return super.passes(new RegExp('^\\d*[,.]?\\d{0,' + this.maxDecimals + '}$'))
  }
}
